<template>
  <div class="edit">
    <h1>Dakgoot types</h1>

    <form class="default-form edit-form" @submit.prevent="">
      <div class="default-form-field">
        <div class="default-form-field-types" style="text-align: left;">
          <div class="row" style="margin-bottom:10px;">
            <span class="item row-header">Naam</span>
            <span class="item row-header">Default Type</span>
            <span class="item row-header">Label</span>
            <span class="item row-header">Omschrijving</span>
            <span class="item row-header">Afbeelding</span>
            <span class="item row-header">Infobox</span>
            <span class="item row-header">Infobox Online</span>
            <span class="item row-header">Tekst links</span>
            <span class="item row-header">Tekst rechts</span>
          </div>

          <div v-for="(dakgoot, i) in dakgootTypes" :key="i" class="default-form-field-types-edit-row">
            <div class="row">
              <div class="item">
                <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="dakgoot.name" @keydown.enter="add(i + 1)">
              </div>

              <div class="item">
                <input class="checkbox" type="checkbox" :id="`isDefault`+i" name="isDefault-checkbox" v-model="dakgoot.isDefault" @change="updateIsDefault(dakgoot)">
                <label :for="`isDefault`+i" class="checkbox-label sizes-form-checkbox" style="float: none; display: inline-flex; margin-right:40px">
                  <mdicon name="check-bold" class="checkbox-label-icon" :class="dakgoot.isDefault ? 'checkbox-label-icon-active' : ''" size="15" />
                </label>
              </div>

              <div class="item">
                <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="dakgoot.label" @keydown.enter="add(i + 1)">
              </div>

              <div class="item">
                <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="dakgoot.description" @keydown.enter="add(i + 1)">
              </div>

              <div class="item">
                <select v-model="dakgoot.uiImage" class="default-form-field-input item">
                  <option v-for="(texture, j) in texturesWithEmpty" :key="'diff'+i+'-'+j" :value="texture.id">{{texture.name}}</option>
                </select>
              </div>
              
              <div class="item">
                <select v-model="dakgoot.infobox" class="default-form-field-input" style="width: 100%">
                  <option v-for="(infobox, j) in infoboxesWithEmpty" :key="'diff'+i+'-'+j" :value="infobox.id">{{infobox.name}}</option>
                </select>
              </div>

              <div class="item">
                <input style="width:16px; height:16px;" type="checkbox" v-model="dakgoot.infoboxOnline">
              </div>

              <div class="item">
                <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="dakgoot.textLeft" @keydown.enter="add(i + 1)">
              </div>

              <div class="item">
                <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="dakgoot.textRight" @keydown.enter="add(i + 1)">
              </div>

              <!-- <button class="default-form-field-button item" @mousedown="remove(i)" >
                <mdicon name="minus" class="default-form-field-button-icon" size="25" />
              </button> -->
            </div>

            <div class="item colors-container" style="background:#f2f5f2;border-radius: 5px; padding: 10px; margin-top: 10px;">
              <div class="colors-section">
                <div class="colors-header">
                  <span class="color-header-item">Label</span>
                  <span class="color-header-item">Hex</span>
                  <span class="color-header-item">UI Hex</span>
                  <span class="color-header-item">Artikelcode</span>
                  <span class="color-header-item">Default</span>
                  <button class="default-form-field-button add-color-btn" @click="addColor(i)">
                    <mdicon name="plus" class="default-form-field-button-icon" size="20" />
                  </button>
                </div>
                <div v-for="(color, colorIndex) in dakgoot.colors" :key="colorIndex" class="color-row">
                  <input type="text" class="default-form-field-input color-input" v-model.trim="color.label">
                  <input type="text" class="default-form-field-input color-input" v-model.trim="color.hexcode">
                  <input type="text" class="default-form-field-input color-input" v-model.trim="color.uiHexcode">
                  <input type="text" class="default-form-field-input color-input" v-model.trim="color.artikelCode">
                  <div class="color-input">
                    <input class="checkbox" type="checkbox" :id="`isDefaultColor`+i+`-`+colorIndex" :name="`isDefaultColor`+i+`-`+colorIndex" v-model="color.isDefault" @change="updateIsDefaultColor(i, colorIndex)">
                    <label :for="`isDefaultColor`+i+`-`+colorIndex" class="checkbox-label sizes-form-checkbox" style="float: none; display: inline-flex; margin-right:40px">
                      <mdicon name="check-bold" class="checkbox-label-icon" :class="color.isDefault ? 'checkbox-label-icon-active' : ''" size="15" />
                    </label>
                  </div>
                  <button class="default-form-field-button color-delete-btn" @mousedown="removeColor(i, colorIndex)">
                    <mdicon name="minus" class="default-form-field-button-icon" size="20" />
                  </button>
                </div>
              </div>
            </div>

            <button style="width:30px; height: 30px; padding: 3px;" class="default-form-field-button item" @mousedown="remove(i)" >
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click="add(dakgootTypes.length)">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="update()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>
    </form>
  </div>
</template>

<script>
import isEqual from 'lodash.isequal'
import { mapGetters } from 'vuex'
import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

export default {
  name: "DakgootTypes",

  components: {
    LoadingButton
  },

  data () {
    return {
      dakgootTypes: [],
      formValid: false,
      loading: false,
    }
  },

  methods: {
    async get () {
      await Promise.all([
        this.$store.dispatch('getDakgootTypes'),
        this.$store.dispatch('getTextures'),
      ])
      this.dakgootTypes = JSON.parse(JSON.stringify(this.data))
    },

    async update () {
      this.loading = true

      let remove = []
      let update = []
      let insert = []

      for (let i = 0; i < this.data.length; i++) {
        const keepId = this.dakgootTypes.find((t) => t.id === this.data[i].id)
        if (!keepId) {
          // dakgootType is removed
          remove.push(this.data[i])
        } else {
          const dakgootTypeChanged = this.dakgootTypes.find((t) => t.id === this.data[i].id && JSON.stringify(t) !== JSON.stringify(this.data[i]))
          if (dakgootTypeChanged) {
            // dakgootType is changed
            update.push(dakgootTypeChanged)
          }
        }
      }

      for (let i = 0; i < this.dakgootTypes.length; i++) {
        if (!this.dakgootTypes[i].id) {
          insert.push(this.dakgootTypes[i])
        }
      }

      try {
        await this.$store.dispatch('updateDakgootTypes', {
          remove: remove,
          update: update,
          insert: insert
        })
      } catch (err) {
        console.log(err)
        this.loading = false
      }

      this.loading = false
      this.dakgootTypes = JSON.parse(JSON.stringify(this.data))
    },

    add (i) {

      if (i === this.dakgootTypes.length) {
        this.dakgootTypes.push({
          id: null,
          name: "",
          label: "",
          description: "",
          uiImage: "",
          textLeft: "",
          textRight: "",
          colors: []
        })
      }

      this.$nextTick(() => {
        document.getElementById('input' + (i)).focus()
      })
    },

    remove (i) {
      this.dakgootTypes.splice(i, 1)
    },

    addColor (dakgootIndex) {
      if (!this.dakgootTypes[dakgootIndex].colors) {
        this.dakgootTypes[dakgootIndex].colors = []
      }
      this.dakgootTypes[dakgootIndex].colors.push({
        label: "",
        hexcode: "",
        uiHexcode: "",
        artikelCode: ""
      })
    },

    removeColor (dakgootIndex, colorIndex) {
      this.dakgootTypes[dakgootIndex].colors.splice(colorIndex, 1)
    },

    updateIsDefault (dakgoot) {
      // Reset all isDefault to false except the one that was just clicked
      this.dakgootTypes.forEach(f => {
        if (f !== dakgoot) {
          f.isDefault = false
        }
      })
    },

    updateIsDefaultColor (dakgootIndex, colorIndex) {
      // Reset all isDefault to false except the one that was just clicked
      this.dakgootTypes[dakgootIndex].colors.forEach((c, i) => {
        if (i !== colorIndex) {
          c.isDefault = false
        }
      })
    }
  },

  computed: {
    ...mapGetters({
      data: "getDakgootTypes",
      textures: 'getTextures',
      infoboxes: 'getInfoboxes',
    }),

    texturesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.textures]
    },

    infoboxesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.infoboxes]
    },
  },

  created () {
    this.get()
  },

  watch: {
    dakgootTypes: {
      deep: true,
      immediate: false,
      handler () {
        if (isEqual(this.dakgootTypes, this.data)) {
          this.formValid = false
        } else {
          this.formValid = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    width: 90%
  }
}

.row {
  display: flex;
  // flex-wrap: wrap; /* Allow items to wrap if needed */
  width: 100%; /* Adjust as necessary */
  &-header {
    padding-left: 5px;
    justify-content: left !important;
  }
  gap: 4px;
}

.item {
  flex: 1; /* Default flex property for other items */
  width: 0px; // dit werkt op een of andere manier
  box-sizing: border-box; /* Include padding and border in width */
  display: flex;
  align-items: flex-start;
  // handig systeem
  &:nth-child(2) {
    flex: 0 0 60px; /* Fixed width of 70px */
  }
  &:nth-child(5) {
    flex: 0 0 200px; /* Fixed width of 70px */
  }
  &:nth-child(6) { // "Infobox"
    flex: 0 0 110px;
  }
  &:nth-child(7) { // "Infobox Online"
    flex: 0 0 60px;
  }
  &:nth-child(8) { // ¯\_(ツ)_/¯
    flex: 0 0 150px;
  }
  &:nth-child(9) {
    flex: 0 0 150px;
  }
}

.default-form-field-types {
  display: block; // overwrite
}
.default-form-field-types-edit-row {
  display: flex;
  flex-direction: column;
  // gap: 10px;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.colors-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 75%;
}

.colors-section {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 100%;
}

.colors-header {
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}

.color-header-item {
  flex: 1;
  // font-size: 12px;
  // font-weight: bold;
  // padding: 5px;
  // text-align: center;
  &:last-child {
    flex: 0 0 30px;
  }
  padding-left: 5px;
  justify-content: left !important;
}

.color-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.color-input {
  flex: 1;
  min-width: 0;
}
input[type="text"].color-input {
  background: #fff;
  border: 1px solid #ccc;
}

.color-delete-btn {
  flex: 0 0 30px;
  height: 30px;
  padding: 2px;
}

.add-color-btn {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-size: 12px;
}

</style>